import { RealtimeClient } from "./RealtimeClient";

export class AccessManagementService {
    constructor(options) {
        this._options = options;
        this._rc = new RealtimeClient();
    }

    streamCardHolders(callback) {
        return this._rc.subscribe("access-management-app", "/cardHolders", {}, function (msg) {
            const response = JSON.parse(msg);
            if (response) {
                if (callback) {
                    callback(null, response);
                }
            }
        });
    }

}
